import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-work-flow-all-status',
  templateUrl: './work-flow-all-status.component.html',
  styleUrls: ['./work-flow-all-status.component.scss']
})
export class WorkFlowAllStatusComponent implements OnInit {

  @ViewChild('workFlowAllStatusTable', { static: true }) public workFlowAllStatusTable: Table;
  
  @Input() applicationId;
  public workFlowAllStatusModel: any = [];
  public userRole: any;

  public loading: boolean = false;
  public subscriptions: any = [];
  public showSubsidyDisbursmentDialogBox: boolean = false;
  public challanPaymentDetails: any=[];

  constructor(
    private deptDashBoardService: DepartmentDashboardService, 
    private route: ActivatedRoute,
    private messageService: MessageService,
    private loader: AppLoaderService
  ) { }

  ngOnInit(): void {
    this.loadData(this.applicationId)

    // if(this.userRole == 'DD Associate'){
    // }else{
    //   this.applicationId = this.route.snapshot.params.applicationId;
    //   // console.log('applicationId', this.route.snapshot.params);
    //   this.loadData(this.applicationId);
    // }
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  loadData(applicationId) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService 
      .workFlowAllStatus(applicationId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('Response Data', data);
          // data.forEach(e=>{
          //   e.AssignDateForSorting = new Date(e.AssignDate);
          // })
          this.workFlowAllStatusModel = data;
          // this.loader.close();
          this.loading = false;
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  onClickSubsidyDisbursment(val){
    this.getChallanPaymentDetails(val?.AppID);
  }

  getChallanPaymentDetails(applicationId){
    this.loading = true;
    let sub = this.deptDashBoardService 
      .getChallanPaymentDetails(applicationId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if(data && data.length>0){
            this.challanPaymentDetails = data[0][0];
            this.showSubsidyDisbursmentDialogBox = true;
          }else{
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data Not Found',
            });
            this.challanPaymentDetails = [];
            this.showSubsidyDisbursmentDialogBox = false;
          }
        },
        error: (err) => {
          this.showSubsidyDisbursmentDialogBox = false;
          this.challanPaymentDetails = [];
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  onCloseDialog(){
    this.showSubsidyDisbursmentDialogBox = false;
  }

}
